import cuid from "cuid";
import { get } from "lodash";
import { useContext, useMemo } from "react";
import OneSignal from "react-onesignal";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { StoreContext } from "shared/store";
import graphql from "utils/api/graphql";
import { KEYS, SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const { user, setUser } = useContext(StoreContext);
  const navigate = useNavigate();
  const {
    state: { contact, qualifier },
  } = useLocation();
  const [createReminder] = useMutation(graphql.mutations.CREATE_REMINDER, {
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.BROKER.QUALIFICATIONS.LIST.path);
    },
    onError: () => {},
  });
  const id = useMemo(() => cuid(), []);

  const initOneSignal = async () => {
    await OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_ID,
      allowLocalhostAsSecureOrigin: true,
    });
    if (!(await OneSignal.isPushNotificationsEnabled())) {
      localStorage.removeItem(KEYS.ONESIGNAL_NOTIFICATION_PROMPT);
      await OneSignal.showSlidedownPrompt();
    }
    const playerId = await OneSignal.getUserId();
    setUser({ user: { ...user, playerId } });
    return playerId;
  };

  const cancel = () =>
    navigate(SCREENS.PRIVATE.BROKER.QUALIFICATIONS.LIST.path);
  const onSubmit = async (_) => {
    const playerId =
      get(user, "playerId", undefined) || (await initOneSignal());
    return createReminder({
      variables: {
        data: {
          id,
          content: _.content,
          scheduledDate: _.scheduledDate,
          playerId,
          contact,
          qualifier,
        },
      },
    });
  };
  return <View cancel={cancel} onSubmit={onSubmit} />;
};

export default Create;
